import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment'
import SurveyGridHeader from '../components/GridComponents/SurveyGridHeader';
import SurveyGridBody from '../components/GridComponents/SurveyGridBody';
import SurveyGridRow from '../components/GridComponents/SurveyGridRow';
import { ElementType, NumberFormat, SelectCombos, CommonResponses, SelectCombosPABS } from '../Enums/constants';


export const PabsUkDigitalTab = () => {
  return (
    <SurveyPage>
      <SurveyTitleArea labelText='' />
      <SurveyContentContainer>
        <SurveySection labelText='Availability'>
          <SurveyElement
            questionNumber='58'
            labelText='Do you have a publicly accessible website?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='WebsiteYN'
          />
        </SurveySection>
        <SurveyConditionalSegment
          showIf={{
            WebsiteYN: { not: CommonResponses.NO.toLowerCase() }
          }}
        >
          <SurveySection labelText='Public Area Website'>
            <SurveyElement
              questionNumber='59'
              labelText='Please indicate which of the following is available to members on your website:'
            />
            <SurveyElement
              questionNumber='59.a'
              labelText='Forms used by members?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='WebDownloadForms'
            />
            <SurveyElement
              questionNumber='59.b'
              labelText='Educational videos (including links to videos posted on YouTube)?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='WebVideoyn'
            />
            <SurveyElement
              questionNumber='59.c'
              labelText='Benefit calculator in non-secure area?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='WebCalculatorNonSecure'
            />
            <SurveyElement
              questionNumber='59.d'
              labelText='Member booklets?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='UKPublicWebBookletsyn'
            />
            <SurveyElement
              questionNumber='59.e'
              labelText='Live web chat?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='UKPublicWebLiveChatYN'
            />
            <SurveyElement
              questionNumber='59.f'
              labelText='Chatbot?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='UKPublicWebChatBotYN'
            />
            <SurveyElement
              questionNumber='60'
              labelText='Does your website:'
            />
            <SurveyElement
              questionNumber='60.a'
              labelText='Is your public website compliant with Web Content Accessibility Guidelines <br/>(WCAG 2.2):'
              subQuestion
            />
            <SurveyElement
              questionNumber='60.a.a1'
              labelText="Fully compliant – Level AA?"
              name='UKPublicWebWCAGFullyLevelAAYN'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber='60.a.a2'
              labelText="Fully compliant – Level A?"
              name='UKPublicWebWCAGCompliantLevelAYN'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber='60.a.a3'
              labelText="Partially compliant?"
              name='UKPublicWebWCAGPartialCompliantYN'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber='60.b'
              labelText="Is your secure website compliant with Web Content Accessibility Guidelines <br/>(WCAG 2.2):"
              subQuestion
            />
            <SurveyElement
              questionNumber='60.b.b1'
              labelText="Fully compliant – Level AA?"
              name='UKSecureWebWCAGFullyLevelAAYN'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber='60.b.b2'
              labelText="Fully compliant – Level A?"
              name='UKSecureWebWCAGCompliantLevelAYN'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber='60.b.b3'
              labelText="Partially compliant?"
              name='UKSecureWebWCAGPartialCompliantYN'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber='60.c'
              labelText='Include screen magnifiers?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='UKPublicWebScreenMagYN'
            />
            <SurveyElement
              questionNumber='60.d'
              labelText='Include screen readers and/or speech recognition tools?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='UKPublicWebScreenReaderYN'
            />
            <SurveyElement
              questionNumber='60.e'
              labelText='Include tools that change the screen colour?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='UKPublicWebChangeColourYN'
            />
          </SurveySection>
          <SurveySection labelText='Secure Member Area Website'>
            <SurveyElement
              questionNumber='61'
              labelText='Does your website have a secure member area where:'
            />
            <SurveyElement
              questionNumber='61.a'
              labelText='Active members can access their own data?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='UKSecureActiveyn'
            />
            <SurveyElement
              questionNumber='61.b'
              labelText='Deferred members can access their own data?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='WebSecureAccessInactive'
            />
            <SurveyElement
              questionNumber='61.c'
              labelText='Pensioners can access their own data?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='UKSecurePensioneryn'
            />
            <SurveyConditionalSegment
              showIf={{
                WebsiteYN: { not: CommonResponses.NO.toLowerCase() }
              }}
            >
              <SurveyElement
                questionNumber='62'
                labelText='Which of the following login security protocols are in use for your secure area website?'
              />
              <SurveyElement
                questionNumber='62.a'
                labelText='Biometric passkey (fingerprint/face)?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKSecureLoginBiometricYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='62.b'
                labelText='Authenticator app?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKSecureLoginAuthAppYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='62.c'
                labelText='Device binding?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKSecureLoginDeviceBindingYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='62.d'
                labelText='MFA (email code)?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKSecureLoginMFAEmailYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='62.e'
                labelText='MFA (SMS or voice call)?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKSecureLoginMFAMobileYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='62.f'
                labelText='Knowledge-based questions (KBA)?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKSecureLoginMFAQuestionYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='63'
                labelText='Which of the following describes your password reset verification process?'
              />
              <SurveyElement
                questionNumber='63.a'
                labelText='Requires passkey, security key, or trusted device/authenticator-based approval?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKPasswordResetPasskeyYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='63.b'
                labelText='Requires two enrolled factors?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKPasswordResetTwoFactorsYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='63.c'
                labelText='Requires one strong enrolled factor?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKPasswordResetOneStrongFactorYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='63.d'
                labelText='Requires only email or SMS/voice code?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKPasswordResetMobileYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='63.e'
                labelText='Requires security questions or personal information?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='UKPasswordResetQuestionYN'
                subQuestion
              />
              <SurveyElement
                questionNumber='64'
                labelText='Can MFA or recovery details be changed without re-authentication?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO_NA}
                name='UKSecureChangedWithoutReAuthYN'
              />
              <SurveyElement
                questionNumber='65'
                labelText='Are users alerted immediately to password, email, phone, or MFA changes?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO_NA}
                name='UKSecureAlertChangesYN'
              />
              <SurveyElement
                questionNumber='66'
                labelText='Can users review and revoke trusted devices and active sessions?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO_NA}
                name='UKSecureRevokeDevicesYN'
              />
              <SurveyElement
                questionNumber='67'
                labelText='Are backup codes or secure recovery options provided instead of security questions?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO_NA}
                name='UKSecureRecoveryOptionsYN'
              />
            </SurveyConditionalSegment>
            <SurveyConditionalSegment
              showIf={{
                or: [
                  { UKSecureActiveyn: { not: CommonResponses.NO.toLowerCase() } },
                  { UKSecurePensioneryn: { not: CommonResponses.NO.toLowerCase() } },
                  { WebSecureAccessInactive: { not: CommonResponses.NO.toLowerCase() } }
                ]
              }}
            >
              <SurveyElement
                questionNumber='68'
                labelText='Provide the number of members that accessed the secure area in the year (count a member only once even if he/she visited multiple times):'
              />
              <SurveyElement
                questionNumber='68.a'
                labelText='Active members'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                subQuestion
                name='UKSecureActiveVisitVol'
                allowUnknown
                placeholder='#, unknown'
                showIf={{
                  UKSecureActiveyn: {
                    not: CommonResponses.NO.toLowerCase()
                  }
                }}
              />
              <SurveyElement
                questionNumber='68.b'
                labelText='Deferred members'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                subQuestion
                name='UKSecureDeferredVisitVol'
                allowUnknown
                placeholder='#, unknown'
                showIf={{
                  WebSecureAccessInactive: {
                    not: CommonResponses.NO.toLowerCase()
                  }
                }}
              />
              <SurveyElement
                questionNumber='68.c'
                labelText='Pensioners'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                subQuestion
                name='UKSecurePensionerVisitVol'
                allowUnknown
                placeholder='#, unknown'
                showIf={{
                  UKSecurePensioneryn: {
                    not: CommonResponses.NO.toLowerCase()
                  }
                }}
              />
              <SurveyElement
                questionNumber='68.d'
                labelText="Total (please provide - even if you can't split between members)"
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                subQuestion
                name='WebUniqueVisitsToSecureArea'
                placeholder='#'
                allowUnknown
              />

              <SurveyElement
                questionNumber='69'
                labelText='Provide the number of registered users (i.e., members that have been supplied with a password and have logged-in at any time historically):'
              />
              <SurveyElement
                questionNumber='69.a'
                labelText='Active members'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                subQuestion
                name='UKSecureRegisteredActive'
                allowUnknown
                placeholder='#, unknown'
                showIf={{
                  UKSecureActiveyn: {
                    not: CommonResponses.NO.toLowerCase()
                  }
                }}
              />
              <SurveyElement
                questionNumber='69.b'
                labelText='Deferred members'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                subQuestion
                name='UKSecureRegisteredDeferred'
                allowUnknown
                placeholder='#, unknown'
                showIf={{
                  WebSecureAccessInactive: {
                    not: CommonResponses.NO.toLowerCase()
                  }
                }}
              />
              <SurveyElement
                questionNumber='69.c'
                labelText='Pensioners'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                subQuestion
                name='UKSecureRegisteredPensioner'
                allowUnknown
                placeholder='#, unknown'
                showIf={{
                  UKSecurePensioneryn: {
                    not: CommonResponses.NO.toLowerCase()
                  }
                }}
              />
              <SurveyElement
                questionNumber='69.d'
                labelText="Total (please provide - even if you can't split between members)"
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                placeholder='#'
                subQuestion
                name='UKSecureRegistered'
              />

              <SurveyElement
                questionNumber='70'
                labelText='Provide the number of visits to the secure area of the website (i.e., if one member logs in 3 times then the answer is 3):'
              />
              <SurveyElement
                questionNumber='70.a'
                labelText='Active members'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                subQuestion
                name='WebTotalVisitsToSecureAreaActive'
                allowUnknown
                placeholder='#, unknown'
                showIf={{
                  UKSecureActiveyn: {
                    not: CommonResponses.NO.toLowerCase()
                  }
                }}
              />
              <SurveyElement
                questionNumber='70.b'
                labelText='Deferred members'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                subQuestion
                name='WebTotalVisitsToSecureAreaDeferred'
                allowUnknown
                placeholder='#, unknown'
                showIf={{
                  WebSecureAccessInactive: {
                    not: CommonResponses.NO.toLowerCase()
                  }
                }}
              />
              <SurveyElement
                questionNumber='70.c'
                labelText='Pensioners'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                subQuestion
                name='WebTotalVisitsToSecureAreaPensioner'
                allowUnknown
                placeholder='#, unknown'
                showIf={{
                  UKSecurePensioneryn: {
                    not: CommonResponses.NO.toLowerCase()
                  }
                }}
              />
              <SurveyElement
                questionNumber='70.d'
                labelText="Total (please provide - even if you can't split between members)"
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                allowUnknown
                placeholder='#, unknown'
                subQuestion
                name='WebTotalVisitsToSecureArea'
              />
            </SurveyConditionalSegment>
            <SurveyConditionalSegment
              showIf={{
                or: [
                  { UKSecureActiveyn: { not: CommonResponses.NO.toLowerCase() } },
                  { UKSecurePensioneryn: { not: CommonResponses.NO.toLowerCase() } },
                  { WebSecureAccessInactive: { not: CommonResponses.NO.toLowerCase() } }
                ]
              }}
            >
              <SurveyElement
                questionNumber='71'
                labelText='Indicate whether the following capabilities are available on your website.'
              />
              <SurveyElement
                inputType='grid'
                styleName={'dataTable digitalTable'}
              >
                <SurveyGridHeader>
                  <SurveyElement
                    labelText=''
                    inputType={ElementType.LABEL}
                    name=''
                  />
                  <SurveyElement
                    labelText='Active'
                    inputType={ElementType.LABEL}
                    tooltip='left'
                    helpText=''
                  />
                  <SurveyElement
                    labelText='Deferred'
                    inputType={ElementType.LABEL}
                    tooltip='left'
                    helpText=''
                  />
                  <SurveyElement
                    labelText='Pensioner'
                    inputType={ElementType.LABEL}
                    tooltip='left'
                    helpText=''
                  />
                </SurveyGridHeader>
                <SurveyGridBody>
                  <SurveyGridRow>
                    <SurveyElement
                      labelText='View'
                      inputType={ElementType.LABEL}
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.a'
                      labelText='Does your secure area show the pension ‘value’ immediately on the landing page?'
                      inputType={ElementType.LABEL}
                      note='The ‘value’ means the pension the member can expect from the scheme.  This might typically be the pension shown in the benefit statement, but could include the value of a DC fund and/or the pension expected.  The key question is whether the member sees the most important information for them ‘up front’.  '
                    />
                    <SurveyElement
                      name='WebShowPensionValueActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                    />
                    <SurveyElement
                      name='WebShowPensionValueDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                    />
                    <SurveyElement
                      name='WebShowPensionValuePensionerYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.b'
                      labelText='The current status of requests? (e.g., see what progress has been made with a transfer request)'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      name='WebWorkflowStatusActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebWorkflowStatusDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebWorkflowStatusPensionerYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.c'
                      labelText='View items sent to / received from a secure mailbox?'
                      inputType={ElementType.LABEL}
                      note='A secure mailbox is not a generic email account for member
                                                    enquiries - it is a facility within a secure area that
                                                    allows the member to send and receive personal messages
                                                    to/from the scheme.'
                    />
                    <SurveyElement
                      name='WebSecureMailboxActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebSecureMailboxDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebSecureMailboxPensionerYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.d'
                      labelText='Pensionable service and salary data?'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      name='WebSalaryServiceHTMLActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebSalaryServiceHTMLDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.e'
                      labelText='A copy of a benefit statement (or view equivalent)?'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      name='WebAdobeMemberStatementActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebAdobeMemberStatementDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.f'
                      labelText='Current transfer value?'
                    />
                    <SurveyElement
                      name='UKWebCurrentTransferValueActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                    />
                    <SurveyElement
                      name='UKWebCurrentTransferValueDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.g'
                      labelText='Pension payment details (i.e., gross amounts, deductions)?'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement />
                    <SurveyElement />
                    <SurveyElement
                      name='PaymentAdviceOnline'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.h'
                      labelText='P60s?'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement />
                    <SurveyElement />
                    <SurveyElement
                      name='WebDuplicateTaxReceipt'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      labelText='Change / Transact'
                      inputType={ElementType.LABEL}
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.i'
                      labelText='Change address?'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      name='WebChangeAddressActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebChangeAddressDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebChangeAddressPensionerYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.j'
                      labelText='Change email address?'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      name='WebChangeEmailActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebChangeEmailDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebChangeEmailPensionerYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.k'
                      labelText='Upload documents such as birth or death certificates?'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      name='WebUploadDocumentsActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebUploadDocumentsDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebUploadDocumentsPensionerYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.l'
                      labelText='Nominate beneficiaries?'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      name='WebChangeBeneficiaryActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebChangeBeneficiaryDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebChangeBeneficiaryPensionerYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.m'
                      labelText='Apply for retirement?'
                      inputType={ElementType.LABEL}
                      helpText=''
                      name=''
                      note='Applying on-line does not simply mean sending an email or secure message asking to retire. It is an automated or
                                                semi-automated process that is likely to include some or all of the following steps: accepting a quotation, uploading
                                                certificates if necessary, adding bank account information etc.'
                    />
                    <SurveyElement
                      name='WebApplyForRetirementClarifiedOnlineActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebApplyForRetirementClarifiedOnlineDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.n'
                      labelText='Is your on-line retirement process capable of being ‘straight through’?'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      name='WebApplyForRetirementStraightThroughActiveYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      pageName='Cost'
                    />
                    <SurveyElement
                      name='WebApplyForRetirementStraightThroughDeferredYN'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                    <SurveyElement />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber='71.o'
                      labelText='Change banking information for the purpose of BACS payments?'
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement />
                    <SurveyElement />
                    <SurveyElement
                      name='WebChangeBanking'
                      inputType={ElementType.RADIOBUTTON}
                      options={SelectCombos.YES_NO_NA}
                      placeholder='£'
                      pageName='Cost'
                    />
                  </SurveyGridRow>
                </SurveyGridBody>
              </SurveyElement>
            </SurveyConditionalSegment>
          </SurveySection>

          <SurveyConditionalSegment
            showIf={{
              or: [
                { UKSecureActiveyn: { not: CommonResponses.NO.toLowerCase() } },
                { UKSecurePensioneryn: { not: CommonResponses.NO.toLowerCase() } },
                { WebSecureAccessInactive: { not: CommonResponses.NO.toLowerCase() } }
              ]
            }}
          >
            <SurveySection labelText='Calculators'>
              <SurveyElement
                questionNumber='72'
                labelText='Do you have an on-line calculator accessible by :'
                pageName='Actives'
              />
              <SurveyElement
                questionNumber='72.a'
                labelText='Active members?'
                name='WebCalculatorYN'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                subQuestion
                pageName='Actives'
              />
              <SurveyElement
                questionNumber='72.b'
                labelText='Deferred members?'
                name='UKWebCalculatorDeferred'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                subQuestion
                pageName='Actives'
              />
              <SurveyConditionalSegment
                showIf={{
                  or: [
                    {
                      WebCalculatorYN: {
                        not: CommonResponses.NO.toLowerCase()
                      }
                    },
                    {
                      UKWebCalculatorDeferred: {
                        not: CommonResponses.NO.toLowerCase()
                      }
                    }
                  ]
                }}
              >
                <SurveyElement
                  questionNumber='72.b.b1'
                  labelText="If yes, to either, is it linked to the member's salary and service data?"
                  name='WebCalculatorLinked'
                  inputType={ElementType.RADIOBUTTON}
                  options={SelectCombos.YES_NO_NA}
                  doubleSubQuestion
                  pageName='Actives'
                />
                <SurveyElement
                  questionNumber='72.b.b2'
                  labelText='Can the member model different retirement ages?'
                  name='WebCalculatorStartDates'
                  inputType={ElementType.RADIOBUTTON}
                  options={SelectCombos.YES_NO_NA}
                  doubleSubQuestion
                  pageName='Actives'
                />
                <SurveyElement
                  questionNumber='72.b.b3'
                  labelText='Can the member model different pension / PCLS combinations?'
                  name='WebCalculatorPaymentOptions'
                  inputType={ElementType.RADIOBUTTON}
                  options={SelectCombos.YES_NO_NA}
                  doubleSubQuestion
                  pageName='Actives'
                />
                <SurveyElement
                  questionNumber='72.b.b4'
                  labelText='Can the member enter numbers from other pension schemes (i.e., to provide a complete retirement income picture)?'
                  name='WebCalculatorAmountFromOtherScheme'
                  inputType={ElementType.RADIOBUTTON}
                  options={SelectCombos.YES_NO_NA}
                  doubleSubQuestion
                  pageName='Actives'
                />
                <SurveyElement
                  questionNumber='72.b.b5'
                  labelText='Do you have a ‘retirement budget’ calculator?'
                  name='WebCalculatorRetirementBudget'
                  inputType={ElementType.SELECT}
                  options={SelectCombosPABS.PUBLIC_SECURE_AREAS_BOTH_NO}
                  doubleSubQuestion
                  pageName='Actives'
                />
                <p>
                  A retirement budget calculator helps the member to contemplate
                  what their income needs might be in retirement - and by
                  extension then to contemplate if their pension will be enough
                  to meet that need.
                </p>
              </SurveyConditionalSegment>
            </SurveySection>
            <SurveySection labelText='Volumes'>
              <SurveyElement
                questionNumber='73'
                labelText='How many members applied to retire on-line?'
              />
              <SurveyElement
                questionNumber='73.a'
                labelText='Active members'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                name='WebApplyForRetirementvolumeClarifiedOnlineActive'
                subQuestion
                allowNA
                allowUnknown
                placeholder='#, unknown, n/a'
              />
              <SurveyElement
                questionNumber='73.b'
                labelText='Deferred'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                name='WebApplyForRetirementvolumeClarifiedOnlineDeferred'
                subQuestion
                allowNA
                allowUnknown
                placeholder='#, unknown, n/a'
              />
              <SurveyElement
                labelText="Total"
                note='If you cannot separate between active and deferred members then please provide the total.'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                name='WebApplyForRetirementvolumeClarifiedOnline'
                subQuestion
                allowNA
                allowUnknown
                placeholder='#, unknown, n/a'
              />

              <SurveyElement
                questionNumber='74'
                labelText='Number of members that looked at their benefit statement on-line (or the data that would normally be available in their benefit statement)?'
              />
              <SurveyElement
                questionNumber='74.a'
                labelText='Active members'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                name='DigitalActiveMemberBenefitStatementOnlineVol'
                subQuestion
                allowNA
                allowUnknown
                placeholder='#, unknown, n/a'
              />
              <SurveyElement
                questionNumber='74.b'
                labelText='Deferred'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                name='DigitalDeferredBenefitStatementOnlineVol'
                subQuestion
                allowNA
                allowUnknown
                placeholder='#, unknown, n/a'
              />
              <SurveyElement
                labelText="Total"
                note='If you cannot separate between active and deferred members then please provide the total.'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                name='DigitalTotalBenefitStatementOnlineVol'
                subQuestion
                allowNA
                allowUnknown
                placeholder='#, unknown, n/a'
              />
              <SurveyElement
                questionNumber='75'
                labelText='How many members used your on-line calculator (in the secure area of your website) in the year?'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                name='WebCalculatorLinkedVol'
                note='Count each member that used the calculator – not the number of times the calculator was used. Please note that this data may not be used in our service score in the current data year, so please do not spend time accessing the data if it is not readily available. It is useful management information however and we are interested simply to see if schemes are measuring. If valuable data is returned then we will share it.'
                allowNA
                allowUnknown
                placeholder='#, unknown, n/a'
                pageName='Actives'
              />
              <SurveyElement
                questionNumber='76'
                labelText='How many members have a completed nomination of beneficiaries and that nomination is available to view on-line?'
                inputType={ElementType.NUMBER}
                format={NumberFormat.INTEGER}
                name='DigitalMemberNominationBeneficiariesAvailableOnlineVol'
                note='The question is about a) the total number of nominations that you hold and b) whether the completed nomination is available to view should the member wish to view it. Note that members may have completed a paper nomination form and the data from that form is now available on-line, in which case they should be counted.'
                allowNA
                allowUnknown
                placeholder='#, unknown, n/a'
              />

              <SurveyElement
                questionNumber='77'
                labelText='Do you have a mobile version of your website? [i.e., a version of your website designed specifically for smart phones and tablets]'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                name='MobileWebsite'
              />
            </SurveySection>
          </SurveyConditionalSegment>

        </SurveyConditionalSegment>
        <SurveySection labelText='Social Media'>
          <SurveyElement
            questionNumber='78'
            labelText='How many social media platforms does your scheme have presence on?'
            inputType={ElementType.NUMBER}
            name='SocialMediaPlatforms'
            placeholder='#'
          />
          <SurveyElement
            questionNumber='78.a'
            labelText='Facebook'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='Facebookyn'
          />
          <SurveyElement
            questionNumber='78.b'
            labelText='X'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='Twitteryn'
          />
          <SurveyElement
            questionNumber='78.c'
            labelText='Instagram'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='InstagramYN'
          />
          <SurveyElement
            questionNumber='78.d'
            labelText='Youtube'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='YoutubeYN'
          />
          <SurveyElement
            questionNumber='79'
            labelText='On average, how many times is new content posted each month?'
            inputType={ElementType.NUMBER}
            placeholder='# days'
            name='SocialMediaPostsFreq'
          />
        </SurveySection>
        <SurveySection labelText='DC (If you are a DC or hybrid scheme)'>
          <SurveyElement
            questionNumber='80'
            labelText='Can members with a DC account access that account on-line?'
            name='UKDCMemberAccountAccess'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO_NA}
          />
          <SurveyConditionalSegment
            showIf={{
              UKDCMemberAccountAccess: [CommonResponses.BLANK, CommonResponses.YES]
            }}
          >
            <SurveyElement
              questionNumber='81'
              labelText='Which of the following are available on-line to members:'
            />
            <SurveyElement labelText='View' inputType={ElementType.LABEL} />
            <SurveyElement
              questionNumber='81.a'
              labelText='A summary of all account activity for any time period?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='WebDCActivity'
            />
            <SurveyElement
              questionNumber='81.b'
              labelText='The current market value of the account?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='WebDCValue'
            />
            <SurveyElement
              questionNumber='81.c'
              labelText='Rates of return for investment options over multiple time periods?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='s_33d'
            />
            <SurveyElement
              questionNumber='81.d'
              labelText="A personal rate of return for the member's account?"
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='s_33e'
            />
            <SurveyElement
              questionNumber='81.e'
              labelText='Estimates of the future account balance at retirement?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='s_33f'
            />
            <SurveyElement
              questionNumber='81.f'
              labelText='Options selected for investment of new contributions?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='s_33i'
            />
            <SurveyElement
              questionNumber='81.g'
              labelText="The charges deducted from the member's account?"
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='StatementsDCCharges'
            />
            <SurveyElement
              labelText='Change / Transact'
              inputType={ElementType.LABEL}
            />
            <SurveyElement
              questionNumber='81.h'
              labelText='Change the options selected for the investment of new contributions?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO_NA}
              subQuestion
              name='UKWebDCChangeOptionsNewyn'
            />
            <SurveyElement
              questionNumber='81.i'
              labelText='Change contribution levels?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              subQuestion
              name='WebDCChangeOptions'
            />
            <SurveyElement
              questionNumber='81.j'
              labelText='Switch accumulated balances between investment options?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO_NA}
              subQuestion
              name='WebDCSwitches'
            />
          </SurveyConditionalSegment>
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  )
}